import { Icon } from '@iconify/react';

function SuspenseDiv() {
  const styles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '80vh',
  };

  return (
    <div style={styles}>
      <Icon icon="svg-spinners:pulse-rings-2" color="grey" width="100" height="100" />
    </div>
  );
}

export default SuspenseDiv;
